/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_DeleteInputs */

const en_notes_delete = /** @type {(inputs: Notes_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete note`)
};

const pt_br2_notes_delete = /** @type {(inputs: Notes_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir anotação`)
};

/**
* | output |
* | --- |
* | "Delete note" |
*
* @param {Notes_DeleteInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_delete = /** @type {((inputs?: Notes_DeleteInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_DeleteInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_delete(inputs)
	return pt_br2_notes_delete(inputs)
});